<template>
  <div>
    <Modal
      width="900"
      :value="showConfirm"
      :title="title"
      :loading="loading"
      @on-ok="submit()"
      @on-visible-change="(status)=>{$emit('visibleChange',status)}">
      <div v-if="title.indexOf('开票')!==-1">
        <Form ref="invoiceForm" :model="invoiceForm" label-position="right" :label-width="100" :rules="billRules" :show-message="false">
          <Row>
            <input-select span="6" label="收款人：" v-model="invoiceForm.Shr" prop="Shr" :disabled="true"></input-select>
            <input-select span="6" label="复核人：" v-model="invoiceForm.Fhr" prop="Fhr" :disabled="true"></input-select>
            <input-select span="8" label="开票人：" v-model="invoiceForm.Kpr" prop="Kpr"></input-select>
          </Row>
          <Row>
            <input-select span="12" label="开票类型：" v-model="invoiceForm.InputMode" type="select" :options="inputMode"></input-select>
            <input-select span="12" label="开票日期：" v-model="invoiceForm.Kprq" type="datetime"></input-select>
          </Row>
          <Row type="flex" align="middle">
            <Col span="2" style="padding:10px 0 10px 15px;margin-right:28px;font-weight:700">开票信息</Col>
            <Col style="flex:1;background:#ccc;height:1px"></Col>
            <Col style="margin-left:10px;cursor:pointer">
              <span @click="showInvoiceInfo=!showInvoiceInfo">
                <Icon :type="showInvoiceInfo?'arrow-up-b':'arrow-down-b'"></Icon>
                <span style="margin-left:10px;color:#808080">{{showInvoiceInfo ? '收起' : '展开'}}</span>
              </span>
            </Col>
          </Row>
          <div :style="{display: showInvoiceInfo?'block':'none'}">
            <Row>
              <input-select span="12" label="汇款单位名称" v-model="orderForm.GhfCompanyName" :disabled="true"></input-select>
              <input-select span="12" label="统一信用代码：" v-model="orderForm.GhfInvoiceTaxNo" :disabled="true"></input-select>
            </Row>
            <Row>
              <input-select span="12" label="银行账号：" v-model="orderForm.GhfBankAccount" :disabled="true"></input-select>
              <input-select span="12" label="开户银行：" v-model="orderForm.GhfBankName" :disabled="true"></input-select>
            </Row>
            <Row>
              <input-select span="12" label="单位地址：" v-model="orderForm.GhfCompanyAddress" :disabled="true"></input-select>
              <input-select span="12" label="注册电话：" v-model="orderForm.GhfTelphone" :disabled="true"></input-select>
            </Row>
          </div>
          <Row type="flex" align="middle">
            <Col span="2" style="padding:10px 0 10px 15px;margin-right:28px;font-weight:700">收件信息</Col>
            <Col style="flex:1;background:#ccc;height:1px"></Col>
            <Col style="margin-left:10px;cursor:pointer">
              <span @click="showReceiedInfo=!showReceiedInfo">
                <Icon :type="showReceiedInfo?'arrow-up-b':'arrow-down-b'"></Icon>
                <span style="margin-left:10px;color:#808080">{{showReceiedInfo ? '收起' : '展开'}}</span>
              </span>
            </Col>
          </Row>
          <div :style="{display: showReceiedInfo?'block':'none'}">
            <Row>
              <input-select span="8" label="收件人姓名：" v-model="chargeObj.CompanyContract" :disabled="true"></input-select>
              <input-select span="8" label="手机号码：" v-model="chargeObj.ContractMobile" :disabled="true"></input-select>
              <input-select span="8" label="固定电话：" v-model="chargeObj.CompanyPhone" :disabled="true"></input-select>
            </Row>
            <Row>
              <input-select span="24" label="收件地址：" v-model="chargeObj.Address" :disabled="true"></input-select>
            </Row>
          </div>
          <Row>
            <input-select span="12" label="发票号码：" v-model="invoiceForm.InvoiceHm" prop="InvoiceHm"></input-select>
            <input-select span="12" label="发票代码：" v-model="invoiceForm.InvoiceDm" :required="invoiceForm.InputMode==='电子普通发票'"></input-select>
          </Row>
          <Row>
            <input-select span="12" label="发票金额：" v-model="invoiceForm.InvoiceAmount" required prop="InvoiceAmount" :disabled="title === '开票(红票)'"></input-select>
            <input-select span="12" label="发票税率：" v-model="invoiceForm.TaxRate" type="select" :options="taxRate"></input-select>
          </Row>
          <Row v-show="invoiceForm.InputMode==='电子普通发票'">
            <input-select span="12" label="电子发票地址：" v-model="invoiceForm.PdfUrl" :readonly="true"></input-select>
            <Button type="primary" size="small" class="btn" @click="openEleInvoice">确认开具发票</Button>
            <Button type="primary" size="small" class="btn" @click="checkEleInvoice">预览</Button>
            <Button type="primary" size="small" class="btn" :disabled="invoiceForm.PdfUrl ? false : true" @click="downInvoice">下载</Button>
          </Row>
        </Form>
      </div>
      <div v-else>
        <Form ref="orderForm" :model="orderForm" label-position="left" :label-width="150" :rules="rules" :show-message="false">
          <Row>
            <input-select span="12" label="预计服务费：" v-model="orderForm.Amount" :disabled="true"></input-select>
            <input-select span="12" label="实收服务费：" v-model="orderForm.DAmount" :required="title==='确认收款'" :disabled="title==='确认退款'"></input-select>
          </Row>
          <Row>
            <input-select span="12" label="支付方式：" v-model="orderForm.PayChannel" :disabled="true" v-if="orderForm.PayChannel==='微信' || orderForm.PayChannel==='支付宝'"></input-select>
            <input-select span="12" label="支付方式：" v-model="orderForm.PayChannel" prop="PayChannel" type="select" :options="PayOptions" v-else></input-select>
            <input-select span="12" label="收款时间：" v-model="orderForm.PayTime" prop="PayTime" type="datetime"></input-select>
          </Row>
          <Row>
            <input-select span="12" label="供货方公司名称：" v-model="orderForm.GhfCompanyName"></input-select>
            <input-select span="12" label="供货方统一信用代码：" v-model="orderForm.GhfInvoiceTaxNo"></input-select>
          </Row>
          <Row>
            <input-select span="12" label="供货方银行账号：" v-model="orderForm.GhfBankAccount" :disabled="title==='确认退款'"></input-select>
            <input-select span="12" label="供货方开户银行：" v-model="orderForm.GhfBankName" :disabled="title==='确认退款'"></input-select>
          </Row>
          <Row>
            <input-select span="12" label="供货方联系方式：" v-model="orderForm.GhfTelphone" :disabled="title==='确认退款'"></input-select>
            <input-select span="12" label="供货方地址：" v-model="orderForm.GhfCompanyAddress" :disabled="title==='确认退款'"></input-select>
          </Row>
          <Row>
            <div class="inputSelect" v-if="title!=='确认退款'">
              <Col span="12">
                <FormItem label="销售方公司名称：" prop="XhfCompanyName" style="width: 100%;margin-bottom: 10px">
                  <Select v-model="orderForm.XhfCompanyName" @on-change="getXhfCompanyData" :disabled="title==='确认退款'">
                    <Option v-for="(item,index) in XhfCompanyOptions" :value="item.label" :label="item.value" :key="index">
                      <div slot>{{ item.value }}</div>
                    </Option>
                  </Select>
                </FormItem>
              </Col>
            </div>
            <input-select span="12" label="销售方公司名称：" v-model="orderForm.XhfCompanyName" :disabled="true" v-else></input-select>
            <input-select span="12" label="销售方银行账号：" v-model="orderForm.XhfBankAccount" :disabled="true"></input-select>
          </Row>
          <Row>
            <input-select span="12" label="销售方开户银行：" v-model="orderForm.XhfBankName" :disabled="true"></input-select>
            <input-select span="12" label="销售方统一信用代码：" v-model="orderForm.XhfInvoiceTaxNo" :disabled="true"></input-select>
          </Row>
          <Row>
            <input-select span="16" label="销售方地址：" v-model="orderForm.XhfCompanyAddress" :disabled="true"></input-select>
          </Row>
        </Form>
      </div>
    </Modal>
    <!-- 电子发票预览 -->
    <ele-invoice 
      :showInvoice="showInvoice" 
      :data="invoiceData"
      @visibleChange="(val)=>{showInvoice=val}">
    </ele-invoice>
  </div>
</template>
<script>
import axios from 'axios'
import qs from "qs"
import inputSelect from '@/components/inputSelect'
import eleInvoice from './eleInvoice'
import { setTimeout } from 'timers'

export default {
  props: {
    showConfirm: Boolean,
    chargeObj: Object
  },
  components: {
    inputSelect,
    eleInvoice
  },
  data() {
    return {
      // baseUrl: 'http://www.choicelink.cn:8888',  // 接口url开头
      baseUrl: 'http://medical.chinapsp.cn:8888',  // 接口url开头
      eleInvUrl: 'http://plat.choicelink.cn',// 发票接口url开头
      title: '',
      obj: {},  // 服务费信息
      orderForm: {},  // 订单信息表单
      rules: {
        PayChannel: [
          { required: true, trigger: 'blur' }
        ],
        PayTime: [
          { required: true, trigger: 'blur' }
        ],
        XhfCompanyName: [
          { required: true, type: 'number', trigger: 'blur' }
        ]
      },
      loading: true,
      // UserCompanyOptions: '',
      PayOptions: [
        { value: '现金', label: '现金' },
        { value: '建设银行', label: '建设银行' },
        { value: '光大银行', label: '光大银行' },
        { value: '农业银行', label: '农业银行' },
        { value: '工商银行', label: '工商银行' },
        { value: '中国银行', label: '中国银行' },
        { value: '广发银行', label: '广发银行' },
        { value: 'POS', label: 'POS' },
        { value: '微信', label: '微信' },
        { value: '支付宝', label: '支付宝' }
      ],  //对话框（确认收费）支付方式
      XhfCompanyOptions: [],
      invoiceForm: {},
      billRules: { 
        Shr: [
          { required: true, trigger: 'blur' },
        ],
        Fhr: [
          { required: true, trigger: 'blur' },
        ],
        Kpr: [
          { required: true, trigger: 'blur' },
        ],
        InvoiceHm: [
          { required: true, trigger: 'blur' },
        ],
        InvoiceAmount: [
          { required: true, trigger: 'blur' }
        ],
      }, // 白票对话框表单验证规则
      taxRate: [
        { value: '0.01', label: '0.01' },
        { value: '0.03', label: '0.03' },
        { value: '0.06', label: '0.06' }
      ],
      // inputMode: [
      //   { value: '录入发票', label: '录入发票' },
      //   { value: '电子发票', label: '电子发票' }
      // ],
      inputMode: [
        { value: '增值税普通发票', label: '增值税普通发票' },
        { value: '增值税专用发票', label: '增值税专用发票' },
        { value: '电子普通发票', label: '电子普通发票' },
        { value: '电子增值税普通发票', label: '电子增值税普通发票' },
        { value: '电子增值税专用发票', label: '电子增值税专用发票' }
      ],
      showInvoice: false,
      invoiceData: {},
      showInvoiceInfo: true,
      showReceiedInfo: true,
      isCorporatePay: false
    }
  },
  computed: {
    user() {
      return this.$store.state.session.user
    }
  },
  methods: {
    // 初始化数据
    init(title, obj, XhfCompany, XhfCompanyOptions, e) {
      this.title = title  //  弹窗标题
      this.obj = obj
      // this.UserCompanyOptions = XhfCompany  // TODO:当前地区销售方开户信息
      this.XhfCompanyOptions = XhfCompanyOptions  //  所有销售方信息
      switch (title) {
        case '添加收费订单':
        case '确认收款':
          if (e.PayChannel == '对公支付') this.isCorporatePay = true 
        case '确认退款': 
          let date = new Date()
          let time = date.getTime()
          this.orderForm = {
            OrderNo: title !== '确认收款' ? `${time}` : e.OrderNo,  //订单编号（默认时间戳）
            PayStatus: obj.Status,//支付状态
            RedOrderNo: e.RedOrderNo,  //红冲订单编号
            OrderStatus: title === '添加收费订单' ? '1' : e.OrderStatus,  //订单状态
            OrderAmountTotal: title === '确认退款' ? -e.OrderAmountTotal : '',  //金额
            PayChannel: title === '添加收费订单' ? '' : e.PayChannel,  //支付方式
            PayTime: title === '添加收费订单' ? '' : e.PayTime,  // 支付时间
            OrderType: e.OrderType,  //订单类型
            IsInvoice: 1,   // 是否开发票
            DebitAndCredit: title === '确认退款' ? '贷' :'借',  //借/贷
            Area: obj.Area,  //地区
            ServiceChargeId: obj.Id,  //服务费表Id
            // GhfBankAccount: title === '确认退款' ? e.GhfBankAccount : '',  //供货方银行账号
            // GhfBankName: title === '确认退款' ? e.GhfBankName : '',  //供货方开户银行
            // GhfCompanyName: title === '确认退款' ? e.GhfCompanyName : '',  //供货方公司名称
            // GhfInvoiceTaxNo: title === '确认退款' ? e.GhfInvoiceTaxNo : '',  //供货方统一信用代码
            // GhfTelphone: title === '确认退款' ? e.GhfTelphone : '',  //供货方联系方式
            // GhfCompanyAddress: title === '确认退款' ? e.GhfCompanyAddress : '',  //供货方地址
            GhfBankAccount: title === '确认退款' ? e.GhfBankAccount : obj.OpenAccount,  //供货方银行账号
            GhfBankName: title === '确认退款' ? e.GhfBankName : obj.OpenBank,  //供货方开户银行
            GhfCompanyName: title === '确认退款' ? e.GhfCompanyName : obj.CompanyName,  //供货方公司名称
            GhfInvoiceTaxNo: title === '确认退款' ? e.GhfInvoiceTaxNo : obj.CompanyNo,  //供货方统一信用代码
            GhfTelphone: title === '确认退款' ? e.GhfTelphone : obj.CompanyPhone,  //供货方联系方式
            GhfCompanyAddress: title === '确认退款' ? e.GhfCompanyAddress : obj.CompanyAddress,  //供货方地址
            XhfBankAccount: title === '确认退款' ? e.XhfBankAccount : '',  //销售方银行账号
            XhfBankName: title === '确认退款' ? e.XhfBankName : '',  //销售方开户银行
            XhfCompanyName: title === '确认退款' ? e.XhfCompanyName : '',  //销售方公司名称
            XhfInvoiceTaxNo: title === '确认退款' ? e.XhfInvoiceTaxNo : '',  //销售方统一信用代码
            XhfTelphone: title === '确认退款' ? e.XhfTelphone : '',  //销售方联系方式
            ProjectId: obj.ProjectId,  //项目ID
            SupplierId: obj.SupplierId,  //供应商ID
            XhfCompanyAddress: title === '确认退款' ? e.XhfCompanyAddress : '',  //销售方地址
            DAmount: title === '确认退款' ? e.OrderAmountTotal : '',  // 实收服务费  必须手填
            Amount: obj.Amount,  // 预计服务费
          }  //确认收款表单
          axios.get(`${this.baseUrl}/UserApi/Account/PageUserRlat?page=1&rows=10&F_UserId=` + obj.SupplierId).then(res => {
            if (res.status == 200) {
              if (res.data.total == 1) {
                this.orderForm.GhfCompanyName = res.data.rows[0]["CompanyName"];
                this.orderForm.GhfInvoiceTaxNo = res.data.rows[0]["F_EnCode"];
              }
            }
          })
          if (title === '添加收费订单') {
            this.submit()
          } else {
            this.$set(this.orderForm, 'Id', e.Id)
          }
          this.dataFomat('orderForm')
          //默认当前地区销售方开户信息
          // if (!!this.UserCompanyOptions) {
          //   this.orderForm.XhfBankAccount = this.UserCompanyOptions.XhfBankAccount
          //   this.orderForm.XhfBankName = this.UserCompanyOptions.XhfBankName
          //   this.orderForm.XhfCompanyAddress = this.UserCompanyOptions.XhfCompanyAddress
          //   this.orderForm.XhfCompanyName = this.UserCompanyOptions.XhfCompanyName
          //   this.orderForm.XhfInvoiceTaxNo = this.UserCompanyOptions.XhfInvoiceTaxNo
          //   this.orderForm.XhfTelphone = this.UserCompanyOptions.XhfTelphone
          // }
        break
        case '开票(白票)': 
        case '开票(红票)': 
          let isRed = title === '开票(红票)' ? true : false
          this.orderForm = isRed ? e : obj
          this.invoiceForm = {
            InvoiceNumber: '', // 发票号码（电子发票）
            InvoiceType: isRed ? 2 : 1, // 发票类型（1-白，2-红）
            InvoiceStatus: isRed ? 2 : 1, // 发票状态（1-已开具，2-已红冲）
            InvoiceHm: isRed&&obj.InputMode=='电子普通发票' ? obj.InvoiceHm : '', // 发票号码
            InvoiceDm: isRed ? obj.InvoiceDm : '', // 发票代码
            InvoiceAmount: isRed ? obj.InvoiceAmount : obj.OrderAmountTotal, // 发票金额
            TaxRate: isRed ? obj.TaxRate : '', // 税率
            Fhr: '李秋红', // 复核人
            Shr: '唐惠英', // 收款人
            Kpr: this.user.fullName, // 开票人
            PdfName: isRed ? obj.PdfName : '', // PDF名字（电子发票）
            PdfUrl: '', // PDF地址（电子发票）
            Kprq: isRed ? obj.Kprq : '', // 开票日期（电子发票）
            OrderNo: isRed ? e.Id : obj.Id, // 对应PSP_Orders id
            VerifyCode: isRed ? obj.VerifyCode : '', // 验证码（电子发票）
            InputMode: isRed ? obj.InputMode : this.chargeObj.InvoiceType == '电子发票' ? '电子普通发票' : this.chargeObj.InvoiceType, // 发票类型
          } 
          if (!isRed && !!obj.XhfCompanyName) {
            if (obj.XhfCompanyName.indexOf("云采链") != -1) {
              this.invoiceForm.TaxRate = '0.06';
            }
            else if (obj.XhfCompanyName.indexOf("采联") != -1) {
              this.invoiceForm.TaxRate = '0.06';
            }
          }
          this.dataFomat('invoiceForm')
        break
      }
    },
    // 表单数据格式化
    dataFomat(form) {
      Object.keys(this[form]).forEach(key => {
        if (this[form][key] !== '' && this[form][key] !== null) {
          switch(key) {
            case 'OrderAmountTotal':
            case 'DAmount':
            case 'Amount':
            case 'InvoiceAmount':
              // 数字类型 转 字符串
              this[form][key] = this[form][key].toString()
            break
            case 'PayTime':
              // 时间格式
              this[form][key] = this[form][key].replace('T', ' ')
            break
          }
        }
      })
    },
    // 获取选中公司
    getXhfCompanyData(e) {
      let arr = this.XhfCompanyOptions.filter(item => {
        return item.label === e
      })
      if (arr[0]) {
        axios.get(`${this.baseUrl}/AgentApi/Orders/PageChargesInfo?page=1&rows=40&Id=${arr[0].label}`).then(res => {
          if (res.status == 200) {
            this.orderForm.XhfBankAccount = res.data.rows[0].XhfBankAccount //销售方银行账号
            this.orderForm.XhfBankName = res.data.rows[0].XhfBankName //销售方开户银行
            // this.orderForm.XhfCompanyName = res.data.rows[0].XhfCompanyName //销售方公司名称
            this.orderForm.XhfTelphone = res.data.rows[0].XhfTelphone //销售方联系方式
            this.orderForm.XhfCompanyAddress = res.data.rows[0].XhfCompanyAddress //销售方地址
            this.orderForm.XhfInvoiceTaxNo = res.data.rows[0].XhfInvoiceTaxNo //销售方统一信用代码
          }
        })
      }
    },
    // TODO: 电子普通发票  测试数据不可用
    openEleInvoice() {
      this.$Modal.confirm({
        title: '开具发票',
        content: '<p>是否确认开具发票？</p>',
        onOk: () => {
          axios.post(`${this.eleInvUrl}/LR_SystemModule/NoticeInvoice/dzfp`, qs.stringify({
            OrderID: this.invoiceForm.OrderNo,
            entity: {
              PSP_kplx: this.invoiceForm.InvoiceType === 1 ? '1' : '2',
              PSP_kpr: this.invoiceForm.Kpr,
              PSP_skr: this.invoiceForm.Shr,
              PSP_fhr: this.invoiceForm.Fhr,
              PSP_xhF_MC: this.orderForm.XhfCompanyName == '广州智采信息科技有限公司' ? '云采链（广州）信息科技有限公司' : this.orderForm.XhfCompanyName,
              PSP_xhF_NSRSBH: this.orderForm.XhfInvoiceTaxNo,
              PSP_xhF_DZ: this.orderForm.XhfCompanyAddress,
              PSP_xhF_DH: this.orderForm.XhfTelphone,
              PSP_xhF_YHZH: this.orderForm.XhfBankName + this.orderForm.XhfBankAccount,
              PSP_ghF_MC: this.orderForm.GhfCompanyName,
              PSP_ghF_NSRSBH: this.orderForm.GhfInvoiceTaxNo,
              PSP_ghF_DZ: this.orderForm.GhfCompanyAddress,
              PSP_ghF_YHZH: this.orderForm.GhfBankAccount,
              PSP_kphjje: this.invoiceForm.InvoiceType === 1 ? this.invoiceForm.InvoiceAmount : -this.invoiceForm.InvoiceAmount,
              PSP_yfP_DM: this.invoiceForm.InvoiceType === 1 ? '' : this.invoiceForm.InvoiceDm, //红冲填
              PSP_yfP_HM: this.invoiceForm.InvoiceType === 1 ? '' : this.invoiceForm.InvoiceHm, //红冲填
              PSP_xmdj: this.invoiceForm.InvoiceAmount,
              PSP_sl: this.invoiceForm.TaxRate,
            }}
          )).then(res => {
            if (res.status == 200) {
              if (!!res.data.PSP_fP_HM) {
                this.invoiceForm.InvoiceHm = res.data.PSP_fP_HM;
                this.invoiceForm.InvoiceDm = res.data.PSP_fP_DM;
                this.invoiceForm.PdfUrl = res.data.PSP_pdF_URL;
                this.invoiceForm.VerifyCode = res.data.PSP_jym;
                this.invoiceForm.PdfName = res.data.PSP_pdF_FILE;
              } else {
                this.$Message.error('开票失败！');
              }
            }
          })
        },
        onCancel: () => {}
      })
    },
    // TODO: 预览
    checkEleInvoice() {
      this.showInvoice = true
      this.invoiceData = {
        robotNum: "",
        invoiceCode: "",
        invoiceNum: "",
        showInvoiceDate: "",
        checkCode: "",
        buyerName: this.orderForm.GhfCompanyName,
        buyerCode: this.orderForm.GhfInvoiceTaxNo,
        buyerAddress: "",
        buyerPhone: "",
        buyerAccountName: "",
        buyerAccount: "",
        goodsName: "*现代服务*平台服务费",
        goodsType: "",
        goodsUnit: "",
        goodsCount: 1,
        goodsPrice: this.invoiceForm.InvoiceAmount,
        goodsTotalPrice: this.invoiceForm.InvoiceAmount,
        goodsTotalPriceTotal: this.invoiceForm.InvoiceAmount,
        goodstax: this.invoiceForm.TaxRate,
        goodsTaxPrice: "",
        goodsTaxPriceTotal: this.invoiceForm.InvoiceAmount,
        totalUpperPrice: "",
        totalLowerPrice: this.invoiceForm.InvoiceAmount,
        salesName: this.orderForm.XhfCompanyName,
        salesCode: this.orderForm.XhfInvoiceTaxNo,
        salesAddressAndPhone:
          this.orderForm.XhfCompanyAddress + "、" + this.orderForm.XhfTelphone,
        salesAccountAndName:
          this.orderForm.XhfBankName + this.orderForm.XhfBankAccount,
        payee: this.invoiceForm.Shr,
        check: this.invoiceForm.Fhr,
        drawer: this.invoiceForm.Kpr
      }
    },
    // 下载电子发票
    downInvoice() {
      if (this.invoiceForm.PdfUrl) {
        window.open(this.invoiceForm.PdfUrl)
      }
    },
    // 提交表单
    submit() {
      let myDate = new Date()
      let time = myDate.toLocaleString('chinese', { hour12: false })  //获取当前时间
      switch (this.title) {
        case '添加收费订单':
          axios.post(`${this.baseUrl}/AgentApi/Orders/AddOrders`, this.orderForm).then(res => {
            this.$Message.success('添加成功')
            this.$emit('visibleChange', false)
            this.$emit('closeModal')  // 关闭订单信息弹窗
            this.$emit('searchEnroll', '1')
          })
        break
        case '确认收款':
          this.$refs.orderForm.validate(valid =>{
            if (valid) {
              if (this.orderForm.DAmount === '') {
                this.loading = false
                this.$Message.error('请输入实收服务费金额！')
                setTimeout(() => {
                  this.loading = true
                },100)
                return
              }
              if (this.orderForm.DAmount < 0) {
                this.loading = false
                this.$Message.error('实收服务费金额不能是负数！')
                setTimeout(() => {
                  this.loading = true
                },100)
                return
              }
              if (!this.orderForm.XhfTelphone || !this.orderForm.XhfBankAccount || !this.orderForm.XhfCompanyAddress) {
                this.loading = false
                this.$Message.error('销售方公司信息有误，请重新选择！')
                setTimeout(() => {
                  this.loading = true
                },100)
                return
              }
              // 修改服务费状态 
              axios.post(`${this.baseUrl}/AgentApi/Orders/UPCharges`, qs.stringify({
                Id: this.orderForm.ServiceChargeId,
                ConfirmTime: time,
                Confirm: this.$store.state.session.user.id,
                Status: 1,
                DAmount: this.orderForm.DAmount,
                PayTime: this.orderForm.PayTime,
                AuditStatus: this.isCorporatePay ? '1' : this.obj.AuditStatus
              }),
              {
                headers: { "Content-Type": "application/x-www-form-urlencoded" }
              }).then(res => {
                if (res.status == 200) {
                  let status = 2  // 未开票已支付
                  if (this.orderForm.OrderStatus == 5) {  //  已开票未收款
                    status = 3  // 已开票已支付
                  }
                  let XhfCompanyName = this.XhfCompanyOptions.filter(item => {
                    return item.label == this.orderForm.XhfCompanyName
                  })
                  console.log(XhfCompanyName,1)
                  XhfCompanyName = XhfCompanyName[0].value
                  console.log(XhfCompanyName,2)
                  // 更新订单信息
                  let order = {
                    Id: this.orderForm.Id,
                    OrderStatus: status,
                    GhfBankAccount: this.orderForm.GhfBankAccount,
                    GhfBankName: this.orderForm.GhfBankName,
                    GhfCompanyAddress: this.orderForm.GhfCompanyAddress,
                    GhfCompanyName: this.orderForm.GhfCompanyName,
                    GhfInvoiceTaxNo: this.orderForm.GhfInvoiceTaxNo,
                    GhfTelphone: this.orderForm.GhfTelphone,
                    OrderAmountTotal: this.orderForm.DAmount,
                    PayChannel: this.orderForm.PayChannel,
                    PayTime: this.orderForm.PayTime,
                    XhfBankAccount: this.orderForm.XhfBankAccount,
                    XhfBankName: this.orderForm.XhfBankName,
                    XhfCompanyAddress: this.orderForm.XhfCompanyAddress,
                    XhfCompanyName: XhfCompanyName,
                    XhfInvoiceTaxNo: this.orderForm.XhfInvoiceTaxNo,
                    XhfTelphone: this.orderForm.XhfTelphone,
                  }
                  // if (this.isCorporatePay) this.$set(order, 'NpId', 1)
                  this.$set(order, 'NpId', 1)
                  axios.post(this.baseUrl+'/AgentApi/Orders/UPOrders', qs.stringify(order)).then(res => {
                    if (res.status == 200) {
                      this.$Message.success('确认成功')
                      this.$emit('visibleChange', false)
                      this.$emit('closeModal')  // 关闭订单信息弹窗
                      this.$emit('searchEnroll', '1')
                    }
                  }).catch(err => { 
                    console.error(err) 
                  })
                }}).catch(err => { 
                console.error(err) 
              })
            } else {
              this.loading = false
              this.$Message.error('请完善信息填写！')
              setTimeout(() => {
                this.loading = true
              },100)
            }
          })
        break
        case '确认退款' :
          if (!this.orderForm.XhfInvoiceTaxNo) {
            this.$Message.error('订单信息有误')
            return
          }
          this.$refs.orderForm.validate(valid =>{
            if (valid) {
              let negativeOrder = JSON.parse(JSON.stringify(this.orderForm))
              delete negativeOrder.Id
              negativeOrder.OrderStatus = '0'
              // 创建红冲订单
              axios.post(`${this.baseUrl}/AgentApi/Orders/AddOrders`, negativeOrder).then(res => {
                axios.post(`${this.baseUrl}/AgentApi/Orders/UPOrders`, qs.stringify({
                  Id: this.orderForm.Id,
                  RedOrderNo: res.data.id,
                  OrderStatus: '4'  // 已红冲或已退款
                })).then(res => {
                  if (res.data == true) {
                    // 修改服务费状态
                    axios.post(`${this.baseUrl}/AgentApi/Orders/UPCharges`, qs.stringify({
                      Id: negativeOrder.ServiceChargeId,
                      Status: 0,
                      DAmount: ''
                    }),
                    {
                      headers: { "Content-Type": "application/x-www-form-urlencoded" }
                    })
                    this.$Message.success('退款成功')
                    this.$emit('visibleChange', false)
                    this.$emit('closeModal')  // 关闭订单信息弹窗
                    this.$emit('searchEnroll', '1')
                  }
                })
              })
            } else {
              this.loading = false
              this.$Message.error('请完善信息填写！')
              setTimeout(() => {
                this.loading = true
              },100)
            }
          })

        break
        case '开票(白票)':
        case '开票(红票)':
          this.$refs.invoiceForm.validate(async(valid) => {
            if (valid) {
              this.invoiceForm.Kprq = this.invoiceForm.Kprq == '' ? time : this.invoiceForm.Kprq
              if (!this.invoiceForm.InvoiceAmount) {
                this.$Message.error('发票金额不能为空!')
                this.loading = false
                return
              }
              if (this.invoiceForm.InvoiceAmount < 0 ) {
                this.$Message.error('发票金额不能为负数!')
                this.loading = false
                return
              }
              if (this.invoiceForm.InputMode==='电子普通发票' && !this.invoiceForm.InvoiceDm) {
                this.$Message.error('电子发票需要填写发票代码!')
                this.loading = false
                return
              }
              if (this.invoiceForm.InputMode==='电子普通发票' && !this.invoiceForm.PdfUrl) {
                this.$Message.error('请确认开具发票!')
                this.loading = false
                return
              }
              let rep = await axios.post(`${this.baseUrl}/AgentApi/Orders/AddOrderInvoice`, this.invoiceForm)
              if (rep.status === 200) {
                if (this.title === '开票(白票)') {
                  let status = 3  // 已开票已支付
                  if (this.orderForm.OrderStatus == 1) {  // 待支付
                    status = 5  //已开票未收款
                  }
                  axios.post(`${this.baseUrl}/AgentApi/Orders/UPOrders`, qs.stringify({
                    Id: this.invoiceForm.OrderNo,
                    OrderStatus: status
                  })).then(res => {
                    if (res.data == true) {
                      this.$Message.success('开票成功')
                      this.$emit('visibleChange', false)
                      this.$emit('closeModal')  // 关闭订单信息弹窗
                      this.$emit('searchEnroll', '1')
                    }
                  })
                } else if (this.title === '开票(红票)') {
                  this.invoiceForm.InvoiceAmount = `-${this.invoiceForm.InvoiceAmount}`
                  axios.post(`${this.baseUrl}/AgentApi/Orders/UPOrderInvoice`, qs.stringify({
                    Id: this.obj.Id,
                    InvoiceStatus: 2
                  })).then(res => {
                    if (res.data == true) {
                      this.$Message.success('已红冲')
                      this.$emit('visibleChange', false)
                      this.$emit('closeModal')  // 关闭订单信息弹窗
                      this.$emit('searchEnroll', '1')
                    }
                  })
                }
              } else {
                this.$Message.error('数据请求失败！')
              }
            } else {
              this.loading = false
              this.$Message.error('请完善信息填写！')
              setTimeout(() => {
                this.loading = true
              },100)
            }
          })
        break
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.ivu-input[disabled],
/deep/.ivu-select-disabled .ivu-select-selection {
  color: #495060 !important;
}
.btn {
  vertical-align: -webkit-baseline-middle;
  margin-left: 16px;
  & + .btn {
    margin-left: 5px; 
  }
}
</style>
